import { HANDLE_PROFILE } from '../actions';

const initialState = {};

//eslint-disable-next-line
export default function (state = initialState, action) {
    switch (action.type) {
        case HANDLE_PROFILE:
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
}
